export default "__VITE_ASSET__b8156935__"